import { ReactNode } from 'react';

import { parseMentionsTemplate } from './parseMentionsText';
import { MentionData } from '../consts';

export default function stringRegexReplace(
  text?: string,
  regex?: RegExp,
  callback?: (mention: MentionData, index: number) => ReactNode,
): ReactNode[] {
  if (!text) return [];
  if (!regex) return [];

  let result = text;
  let prevIndex = 0;
  const textParts: ReactNode[] = [];

  parseMentionsTemplate(text).forEach(
    ({ template, type, id, name, index, key }) => {
      // eslint-disable-next-line better-mutation/no-mutating-methods -- local accumulator array
      textParts.push(text.substring(prevIndex, index));
      // eslint-disable-next-line better-mutation/no-mutating-methods -- local accumulator array
      textParts.push(callback?.({ id, name, type }, key));
      result = text.substring(index + template.length);
      prevIndex = index + template.length;
    },
  );

  textParts.push(result);

  return textParts.filter((_) => _);
}
